/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./ns-combo-select.html";

export class NsComboSelect extends PolymerElement {
  constructor() {
    super();
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get is() {
    return "ns-combo-select";
  }

  ready() {
    super.ready();
    this.$.chevron.addEventListener("click", this._toggleDropdown.bind(this));
    this.$.searchInput.addEventListener("keyup", this._handleKeyUp.bind(this));
    this.$.searchInput.addEventListener("blur", this._handleBlur.bind(this));
  }

  static get properties() {
    return {
      filteredItems: {
        type: Array,
        notify: true
      },
      /**
       * List of items
       */
      items: {
        type: Array,
        notify: true,
        observer: "_itemsListChanged"
      },
      placeholder: {
        type: String,
        value: "Select Item"
      },
      selected: {
        type: Number,
        notify: true,
        observer: "_selectedChanged"
      },
      toggleDropdown: {
        type: Boolean,
        observer: "_handleToggle"
      }
    };
  }

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  _itemsListChanged(e) {
    this.set("filteredItems", this.items);
  }

  _selectedChanged(newVal) {
    this.$.searchInput.value = this.getTextById(newVal);
    this._close();
    this.dispatchEvent(
      new CustomEvent("selectedchanged", { bubbles: true, composed: true })
    );
  }

  getTextById(id) {
    if (this.items) {
      id = id || this.selected;
      let item = this.items.find((item) => (item ? item.id === id : false));
      return item ? item.text : "";
    }
  }

  _onItemSelect(e) {
    let id = e.currentTarget.dataset.id;
    e.target.parentElement.parentNode.host.selected = id;
  }

  _handleFocus(e) {
    e.currentTarget.value = "";
  }

  _handleBlur() {
    // delay until _onItemSelect runs through
    setTimeout(() => {
      this.$.searchInput.value = this.getTextById() || "";
      this._close();
    }, 400);
  }

  _handleToggle(newVal) {
    if (newVal) {
      this.$.searchInput.focus();
    }
  }

  _toggleDropdown() {
    this.toggleDropdown = !this.toggleDropdown;
    this._itemsListChanged();
    this.$.dropdown.className = this.toggleDropdown
      ? this.$.dropdown.className + " opened"
      : this.$.dropdown.className.split(" opened").join("");
    this.$.searchInput.value = this.selected ? this.getTextById() : "";
  }

  _open() {
    if (this.$.dropdown.className.indexOf(" opened") === -1) {
      this.$.dropdown.className += " opened";
      this.toggleDropdown = true;
    }
  }

  _close() {
    this.$.dropdown.className = this.$.dropdown.className
      .split(" opened")
      .join("");
    this.toggleDropdown = false;
  }

  _handleKeyUp(e) {
    let key = e.target.value.toLowerCase();
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.set(
        "filteredItems",
        this.items.filter((item) => item.text.toLowerCase().indexOf(key) !== -1)
      );
      this._open();
    }, 300);
  }

  convertItems(list) {
    return list.map((item, index) => {
      return {
        id: index,
        text: item
      };
    });
  }

  _handleSearchIconClick(e) {
    e.target.parentElement.querySelector("input").focus();
  }
}

window.customElements.define(NsComboSelect.is, NsComboSelect);
